<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M9.375 1.72656C8.86975 1.82081 8.27632 2.02395 7.36477 2.33598L6.88742 2.49938C4.38193 3.35701 3.12919 3.78583 2.8146 4.23405C2.50688 4.6725 2.50015 5.95684 2.5 8.50661L9.375 6.2149V1.72656Z"
      fill="currentColor"
    />
    <path
      d="M9.375 7.53125L2.5 9.82292V9.99026C2.5 14.6887 6.03247 16.9687 8.2488 17.9368C8.67442 18.1228 8.94933 18.2428 9.375 18.2972V7.53125Z"
      fill="currentColor"
    />
    <path
      d="M10.625 18.2972V7.53125L17.5 9.82292V9.99026C17.5 14.6887 13.9675 16.9687 11.7512 17.9368C11.3256 18.1228 11.0507 18.2428 10.625 18.2972Z"
      fill="currentColor"
    />
    <path
      d="M10.625 6.2149V1.72656C11.1302 1.82081 11.7237 2.02395 12.6353 2.33598L13.1126 2.49938C15.6181 3.35701 16.8708 3.78583 17.1854 4.23405C17.4932 4.6725 17.4998 5.95684 17.5 8.50661L10.625 6.2149Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'RoleManagementIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>